import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=6f73b60a&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=js"
export * from "./Matrix.vue?vue&type=script&lang=js"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=6f73b60a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73b60a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/Matrix.vue
// module id = 1971
// module chunks = 31